<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.25 11.75H2.375C1.33947 11.75 0.5 12.5895 0.5 13.625C0.5 14.6605 1.33947 15.5 2.375 15.5H13.25"
      :stroke="color"
      stroke-linecap="round"
    />
    <path
      d="M13.25 15.5C12.2145 15.5 11.375 14.6605 11.375 13.625C11.375 12.5895 12.2145 11.75 13.25 11.75"
      :stroke="color"
      stroke-linecap="round"
    />
    <path
      d="M7.75368 4.00368L6.875 3.125L5.99632 4.00368H4.75368V5.24632L3.875 6.125L4.75368 7.00368V8.24632H5.99632L6.875 9.125L7.75368 8.24632H8.99632V7.00368L9.875 6.125L8.99632 5.24632V4.00368H7.75368Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M0.5 13.625V3.125C0.5 1.67525 1.67525 0.5 3.125 0.5H10.625C12.0747 0.5 13.25 1.67525 13.25 3.125V11.75"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
